<template>
    <div :style="cssVars">
        <loader-c v-if="isLoading"></loader-c>

        <!-- Layout body -->
        <slot v-else></slot>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import LoaderC from './LoaderComponent.vue';

import loadGoogleTagManager from '../../../google/tagManager';
import loadGoogleAnalytics from '../../../google/analytics';
import loadFacebookPixel from '../../../facebook/pixel';
import loadFreshWorks from '../../../freshdesk/freshworks';
import loadHotjar from '../../../hotjar/hotjar';

import {
    checkCatch,
    injectCss,
    shadeColor,
    showMessage,
} from '../../../utils';

export default {

    components: {

        LoaderC,

    },

    data() {

        return {

            isLoading: true,

            configVersion: 0,
            localConfigVersion: null,

            template1: '',
            template2: '',

            primaryColor: '#608e9e',
            secondaryColor: '#f4a8bf',
            footerColor: '#608e9e',

        };

    },

    computed: {

        ...mapGetters([

            'getSindykIntegration',

        ]),

        cssVars() {

            return {

                '--primary-color': this.primaryColor,
                '--primary-dark-color': shadeColor(this.primaryColor, -10),
                '--primary-alpha-color': `${this.primaryColor}40`,
                '--secondary-color': this.secondaryColor,
                '--secondary-dark-color': shadeColor(this.secondaryColor, -10),
                '--secondary-alpha-color': `${this.secondaryColor}40`,
                '--footer-color': this.footerColor,

            };

        },

    },

    async created() {

        await this.getMixTemplates();

        this.getConfigVersion();

        this.checkUserSession(this.$page.props.authCheck);
        this.checkShoppingCart();
        this.checkCoupon();
        this.storeIsCambioBookstore();
        this.storeShipping();

    },

    mounted() {

        this.getColors();

    },

    methods: {

        ...mapActions([

            'checkShoppingCart',
            'checkUserSession',
            'checkCoupon',
            'storeIsCambioBookstore',
            'storeShipping',
            'checkSindykIntegration',
            'checkTemplateId',

        ]),

        configsLoaded() {

            this.getColors();

            this.isLoading = false;

        },

        getColors() {

            const colors = $.parseJSON(localStorage.getItem('colors'));

            if (colors) {

                this.primaryColor = colors.primary;
                this.secondaryColor = colors.secondary;
                this.footerColor = colors.footer;

            }

        },

        getConfigVersion() {

            axios
                .get('/configs/version')
                .then((response) => {

                    const { data } = response;

                    if (!data.success) {

                        showMessage('error', 'Atención', data.message);
                        return;

                    }

                    this.configVersion = data.data;

                    this.validateConfigVersion();

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

        async validateConfigVersion() {

            this.localConfigVersion = $.parseJSON(localStorage.getItem('config_version'));

            if (this.configVersion == this.localConfigVersion) {

                await this.initializeConfigurations();

                this.configsLoaded();

                return;

            }

            this.getConfigurations();

        },

        getConfigurations() {

            axios
                .get('/configs/data')
                .then(async (response) => {

                    let { data } = response;

                    if (!data.success) {

                        showMessage('error', 'Atención', data.message);
                        return;

                    }

                    data = data.data;

                    $.each(data, (i, j) => {

                        localStorage.setItem(i, j);

                    });

                    localStorage.setItem('config_version', this.configVersion);

                    this.storeIsCambioBookstore();
                    this.storeShipping();

                    await this.initializeConfigurations();

                    this.getItemsCategories();

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

        getItemsCategories() {

            axios
                .get('/inventory/items/categories-subcategories')
                .then((response) => {

                    const { data } = response;

                    if (!data.success) {

                        showMessage('error', 'Atención', data.message);
                        return;

                    }

                    localStorage.setItem('categories', JSON.stringify(data.data));

                    this.configsLoaded();

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

        async getMixTemplates() {

            await axios
                .get('/configs/mix-templates')
                .then((response) => {

                    const { data } = response;

                    this.template1 = data.data.template_1;
                    this.template2 = data.data.template_2;

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

        async initializeConfigurations() {

            await this.loadTemplateStyles();

            this.checkSindykIntegration();
            this.checkTemplateId();

            this.loadGoogleTagManager();
            this.loadGoogleAnalytics();
            this.loadFacebookPixel();
            this.loadFreshWorks();
            this.loadMetaTags();
            this.loadHotjar();

        },

        async loadTemplateStyles() {

            let templateId = JSON.parse(localStorage.getItem('template_id'));
            templateId = templateId || 1;
            let templatePath = this.template1;

            if (templateId == 2) {

                templatePath = this.template2;

            }

            await injectCss(templatePath);

        },

        loadGoogleTagManager() {

            const google = JSON.parse(localStorage.getItem('google'));

            if (google && google.tag_manager && google.tag_manager.tracking_id) {

                loadGoogleTagManager(window, document, 'script', 'dataLayer', google.tag_manager.tracking_id);

            }

        },

        loadGoogleAnalytics() {

            const google = JSON.parse(localStorage.getItem('google'));

            if (google && google.analytics && google.analytics.traking_id) {

                loadGoogleAnalytics(google.analytics.traking_id);

            }

        },

        loadFacebookPixel() {

            const facebook = JSON.parse(localStorage.getItem('facebook'));

            if (facebook && facebook.pixel && facebook.pixel.id) {

                loadFacebookPixel(facebook.pixel.id);

            }

        },

        loadFreshWorks() {

            const freshdesk = JSON.parse(localStorage.getItem('freshdesk'));

            if (freshdesk && freshdesk.freshworks && freshdesk.freshworks.id) {

                loadFreshWorks(freshdesk.freshworks.id);

            }

        },

        loadHotjar() {

            if (this.getSindykIntegration) { // Just for Cambio

                loadHotjar(2964005);

            }

        },

        loadMetaTags() {

            const companyData = $.parseJSON(localStorage.getItem('company_data'));

            if (companyData) {

                document.querySelector('meta[name="description"]').setAttribute('content', companyData.ecommerce_name);

            }

        },

    },

};
</script>
